import { cn } from "@repo/utils";

type ActionStatusIndicatorProps = {
  children: React.ReactNode;
  disabled?: boolean;
};

export const ActionStatusIndicator = ({ disabled, children }: ActionStatusIndicatorProps) => {
  return (
    <span
      role="img"
      title="This status has actions attached"
      aria-label="This status has actions attached"
    >
      <div
        className={cn("flex size-5 items-center justify-center rounded-full border", {
          "border-yellow-500 text-yellow-500": !disabled,
        })}
      >
        {children}
      </div>
    </span>
  );
};
